import { createStyles, Theme } from "@material-ui/core";
import { green } from '@material-ui/core/colors';
import bg from '../assets/header-bg.jpg'
const GlobalStyle = (theme: Theme) => createStyles({
    wrapper: {
        margin: theme.spacing(),
        position: 'relative',
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        /*marginTop: -12,
        marginLeft: -12,*/
    },
    appBarSpacer: theme.mixins.toolbar,
    frontEndBackgroundContainer: {
        backgroundColor: '#284770',
        height: '100vh'
    },
    frontEndBackground: {
        backgroundImage: `url(${bg})`,
        opacity: 0.3,
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: 1
    }
})
export default GlobalStyle;


// WEBPACK FOOTER //
// ./src/components/GlobalStyles.ts